<template>
    <div class="my-progress">
        <div class="progress-containter" :style="{'width': myWidth+'px', 'height': myHeight+'px'}">
            <!-- <transition name="slide"> -->
                <div class="progress-inner-box" :style="{'width': totalRate+'%', 'height': myHeight+'px'}" v-if="widthInnerData">
                    <div class="progress-inner" :style="{'width': widthInnerData['future_width']+'%', 'height': myHeight+'px'}">
                        <div class="progress-text" :style="{'height': myHeight+'px'}">{{judgeValue(widthInnerData['future'])}}</div>
                    </div>
                    <span style="margin-left: 40px; color: #fff">{{judgeValue(widthInnerData['borrow'])}}</span>
                    <!-- <div class="progress-inner right">
                        <div class="progress-text" :style="{'height': myHeight+'px'}">{{judgeValue(widthRight)}}</div>
                    </div> -->
                </div>
            <!-- </transition> -->
            <div class="progress-container-text">
                <!-- <span v-if="Number(widthData) < 70">{{judgeValue(widthData)}}</span> -->
            </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable */

export default {
    data() {
        return {
            // proressWidth: 30,
            usedAsset: '',
            remainAsset: '',
        }
    },
    props: {
        'progressWidth': Object,
        'myWidth': Number,
        'myHeight': Number,
        'widthRight': '',
    },
    computed: {
        widthInnerData: function () {
            if (typeof this.progressWidth !== 'undefined') {
                if (this.progressWidth['total'] !== 0) {
                    var borrow_used = Number(this.progressWidth['borrow']);
                    var future_used = Number(this.progressWidth['future']);
                    var total_used = (borrow_used+future_used) / this.progressWidth['total'];
                    var future_width = (future_used / (borrow_used+future_used)) * 100
                    return {
                        'borrow': (borrow_used / this.progressWidth['total'] * 100).toFixed(2),
                        'future': (future_used / this.progressWidth['total'] * 100).toFixed(2),
                        'future_width': future_width.toFixed(2)
                    };
                } else {
                    return 0;
                }
            } 
        },

        // 计算总进度条比例
        totalRate: function () {
            if (this.progressWidth) {
                if (this.progressWidth['total'] !== 0) {
                    var borrow_used = Number(this.progressWidth['borrow']);
                    var future_used = Number(this.progressWidth['future']);
                    return ((borrow_used+future_used) / this.progressWidth['total'] * 100).toFixed(2);
                } else {
                    return 0;
                }
            } else {
                return 0;
            }
            
        }
    },
    methods: {
        judgeValue(data) {
            if (String(data) == '0.00') return '';
            else if (String(data) == '0') return '';
            return data+'%';
        },
    }
}
</script>

<style lang="scss" scoped>
    .my-progress{
        margin-right: 3px;
        .progress-containter{
            // border: 1px solid #5a6361;
            height: 18px;
            width: 110px;
            display: flex;
            justify-content: flex-start;
            background-color: #3e403f;
            .progress-container-text{
                font-size: 12px;
                line-height: 18px;
                margin-left: 2px;
                color: #fff;
            }
            .right {
                background-color: transparent;
                // background-repeat: no-repeat;
                // background-size: 0;
                // animation: move 4s ease both;
            }
            .progress-inner-box {
                display: flex;
                height: 18px;
                background: linear-gradient(#3bc8e8,#403e3e, #3bc8e8);
                background-repeat: no-repeat;
                background-size: 0;
                animation: move 4s ease both;
            }
            .progress-inner{
                // border: 1px solid #969292;
                height: 18px;
                background: linear-gradient(#9dd026,#403e3e, #9dd026);
                background-repeat: no-repeat;
                background-size: 0;
                animation: move 4s ease both;
                .progress-text{
                    font-size: 12px;
                    line-height: 18px;
                    color: #fff;
                    text-align: right !important;
                }
            }
            @keyframes move {
                100%{
                    background-size: 100%;
                }
            }
        }
    }

    @media screen and (max-width: 800px) {
        .my-progress{
            .progress-containter{
                width: 100px;
                // height: 14px;
            }
        }
    }
    @media screen and (max-width: 420px) {
        .my-progress{
            // display: none;
            .progress-containter{
                width: 80px;
                height: 14px;
                .progress-inner{
                    height: 14px;
                }
                .progress-container-text{
                    font-size: 12px;
                    line-height: 14px;
                }
            }
        }
    }
</style>
